module.exports = __webpack_public_path__ + "static/media/face6a.c13c0f3f.jpg";